import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/08e952d7424d8590c76d58707e88eabe.jpeg",
      title: "Crafting Excellence Through Dedication",
      subtitle: "A journey of achievements, growth, and meaningful contributions"
    },
    {
      image: "https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/8ee82c11ab50aa7bf9ebd7923d4c56a3.jpeg",
      title: "Making a Difference Every Day",
      subtitle: "Committed to service, community, and positive impact"
    },
    {
      image: "https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/2274ac6e190a7da48ad2ff8e38762f76.jpeg",
      title: "Leading with Purpose and Passion",
      subtitle: "Inspiring change and empowering communities through action"
    },
    {
      image: "https://static.readdy.ai/image/165557c1c60078d8d9753efdcb1d1569/f29b528317ffca190ebc1aa7b9df7de7.jpeg",
      title: "Building Connections That Matter",
      subtitle: "Creating positive change through collaboration and dedication"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-all duration-1000 ${
            currentSlide === index ? 'opacity-100 scale-100' : 'opacity-0 scale-105'
          }`}
        >
          <img
            src={slide.image}
            alt={`Hero Background ${index + 1}`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        </div>
      ))}
      
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <div className="mb-6 inline-block px-6 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full">
          <p className="text-sm font-medium text-white tracking-wide">Welcome to My Portfolio</p>
        </div>
        
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-8 leading-tight tracking-tight animate-fadeIn">
          {slides[currentSlide].title}
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-12 leading-relaxed max-w-3xl mx-auto font-light">
          {slides[currentSlide].subtitle}
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
          <button
            onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
            className="group px-10 py-4 bg-white text-gray-900 text-base font-semibold rounded-full hover:bg-gray-100 hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer shadow-xl transform hover:scale-105"
          >
            <span className="flex items-center gap-2">
              Explore My Journey
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </span>
          </button>
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-10 py-4 bg-white/10 backdrop-blur-md border-2 border-white text-white text-base font-semibold rounded-full hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
          >
            Connect With Me
          </button>
        </div>

        <div className="mt-16 flex items-center justify-center gap-12 text-white">
          <div className="text-center">
            <div className="text-4xl font-bold mb-1">600+</div>
            <div className="text-sm text-white/80 font-light">Families Reached</div>
          </div>
          <div className="w-px h-12 bg-white/30"></div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-1">20+</div>
            <div className="text-sm text-white/80 font-light">Awards & Honors</div>
          </div>
          <div className="w-px h-12 bg-white/30"></div>
          <div className="text-center">
            <div className="text-4xl font-bold mb-1">100+</div>
            <div className="text-sm text-white/80 font-light">Communities Served</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-24 left-1/2 transform -translate-x-1/2 flex gap-3 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${
              currentSlide === index ? 'bg-white w-12' : 'bg-white/40 hover:bg-white/70 w-8'
            }`}
          ></button>
        ))}
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
          className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-white/50 hover:border-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-xl text-white"></i>
        </button>
      </div>
    </section>
  );
}
